module.exports = "<p>copyright {{now.getFullYear()}} Idea Foundry</p>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Release/InzuzoA/InzuzoA/src/app/components/footer/footer.html
// module id = ../../../../../src/app/components/footer/footer.html
// module chunks = main